// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fms-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.logo-section {
  float: left;
  padding: 0 20px 0 0px;
  display: inline-flex;
}
.logo-section > a {
  align-self: center;
  margin-left: 10px;
}
.logo-section .logo {
  height: auto;
  max-height: 38px;
  max-width: 150px;
  margin-left: 5px;
  margin-top: 0px;
  display: block;
}
.logo-section .icon {
  vertical-align: top;
}
.logo-section .collapse-header {
  background: none;
  border: 0;
  float: left;
  padding: 9px 12px;
  border-radius: 0 0 26px 0;
  cursor: pointer;
  outline: 0;
  color: white;
  background: #00b26f;
}

.left-nav {
  float: left;
}

.right-nav {
  float: right;
}
.right-nav .nav {
  margin-left: 58px;
}
.right-nav .sub-menu.right-menu {
  left: auto;
  right: 0;
}

.nav-container {
  height: 46px;
  font-size: 12px;
}
.nav-container:before, .nav-container:after {
  clear: both;
  content: "";
  display: block;
}

.nav {
  list-style: none;
  margin: 0;
  padding: 0;
}
.nav > li {
  float: left;
  margin-right: 4px;
  color: #666;
}
.nav > li > a {
  padding: 8px 15px;
  font-weight: 400;
  font-size: 13px;
  border-radius: 6px;
  margin-top: 5px;
}
.nav a {
  display: block;
  padding: 9px;
  color: #666;
  text-decoration: none;
  line-height: 16px;
}
.nav svg {
  margin-right: 4px;
  min-width: 1.25em;
  min-height: 1.25em;
  vertical-align: top;
}
.nav span {
  vertical-align: top;
}

.right-nav svg {
  margin-right: 0;
}
.right-nav .nav > li > a {
  padding-left: 15px;
  padding-right: 15px;
}

.nav > li > a.active, .nav > li:hover > a {
  background: #00b26f;
  color: #fff;
  border-top-color: #008e59;
}

.apps-menu .scrollable-area {
  list-style-type: none;
  padding: 0;
  margin: 0;
  height: 340px;
  overflow: auto;
}

.apps-menu .default-view {
  text-align: center;
}
.apps-menu .default-view li {
  display: inline-block;
  width: 30%;
  text-align: center;
  vertical-align: top;
  padding: 0;
}
.apps-menu .default-view a {
  box-sizing: border-box;
  border: 1px solid transparent;
  display: block;
  height: 93px;
  padding: 0;
  padding-top: 20px;
}
.apps-menu .default-view a:hover {
  color: #00c179;
  background: none;
  border-color: #e6e6e6;
}
.apps-menu .default-view .apps-menu-icon {
  display: block;
  margin: 0 auto 10px;
  min-width: 32px;
  min-height: 32px;
}

.apps-search-form {
  position: relative;
  padding: 10px 15px 10px 45px;
}
.apps-search-form .toggle-apps-view {
  position: absolute;
  top: 0;
  left: 0;
  color: #666;
  padding: 12px 15px;
}
.apps-search-form .toggle-apps-view svg {
  color: currentColor;
}
.apps-search-form .searchAppsTextField {
  width: 100%;
  outline: 0;
  padding: 2px 7px 2px 20px;
  box-sizing: border-box;
}
.apps-search-form .appsSearchFrom {
  position: relative;
}
.apps-search-form .appsSearchFrom svg {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px;
  min-width: inherit;
  min-height: inherit;
  color: #e6e6e6;
}

.viewAllApps {
  background: #e6e6e6;
  padding: 6px 12px;
  margin-top: 36px;
}

.menuIcon {
  display: none !important;
  padding: 5px;
  color: #666;
  cursor: pointer;
}

.nav-collapse {
  transition: all 5s ease;
}

.demo-notification-bar {
  color: #fff;
  padding: 6px 12px;
}
.demo-notification-bar a {
  color: #ff2;
  text-decoration: underline;
}

.notification-info {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
}

@media (max-width: 1199px) {
  .nav > li > a {
    padding: 6px 15px 12px;
  }
}
@media (max-width: 959px) {
  .logo-section,
  .right-nav,
  .left-nav {
    float: none;
  }
  .nav-collapse.collapse {
    height: 0;
    overflow: hidden;
  }
  .nav > li {
    float: none;
  }
  .menuIcon {
    display: block !important;
  }
  .logo-section {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,4CAAA;AAAF;;AAEA;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;AACF;AAAE;EACE,kBAAA;EACA,iBAAA;AAEJ;AAAE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAEJ;AAAE;EACE,mBAAA;AAEJ;AAAE;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,mBCNM;ADQV;;AA+BA;EACE,WAAA;AA5BF;;AA8BA;EACE,YAAA;AA3BF;AA6BE;EACE,iBAAA;AA3BJ;AA6BE;EACE,UAAA;EACA,QAAA;AA3BJ;;AAuDA;EACE,YAAA;EACA,eAAA;AApDF;AAuDE;EAEE,WAAA;EACA,WAAA;EACA,cAAA;AAtDJ;;AAyDA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAtDF;AAuDE;EACE,WAAA;EACA,iBAAA;EACA,WClGQ;AD6CZ;AAsDI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AApDN;AAuDE;EACE,cAAA;EACA,YAAA;EACA,WC9GQ;ED+GR,qBAAA;EACA,iBAAA;AArDJ;AAuDE;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AArDJ;AAuDE;EACE,mBAAA;AArDJ;;AAyDE;EACE,eAAA;AAtDJ;AAyDE;EACE,kBAAA;EACA,mBAAA;AAvDJ;;AA6DI;EAEE,mBC1II;ED2IJ,WC1IO;ED2IP,yBC1Ia;AD+EnB;;AAgEA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;AA7DF;;AA+DA;EACE,kBAAA;AA5DF;AA6DE;EACE,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AA3DJ;AA6DE;EACE,sBAAA;EACA,6BAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AA3DJ;AA4DI;EACE,cCvMO;EDwMP,gBAAA;EACA,qBC7KQ;ADmHd;AA6DE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA3DJ;;AA+DA;EACE,kBAAA;EACA,4BAAA;AA5DF;AA6DE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WCpLO;EDqLP,kBAAA;AA3DJ;AA4DI;EACE,mBAAA;AA1DN;AA6DE;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;AA3DJ;AA6DE;EACE,kBAAA;AA3DJ;AA4DI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cCpNQ;AD0Jd;;AA+DA;EACE,mBC1NY;ED2NZ,iBAAA;EACA,gBAAA;AA5DF;;AA8DA;EACE,wBAAA;EACA,YAAA;EACA,WChOU;EDiOV,eAAA;AA3DF;;AA6DA;EACE,uBAAA;AA1DF;;AA6DA;EACE,WAAA;EACA,iBAAA;AA1DF;AA2DE;EACE,WAAA;EACA,0BAAA;AAzDJ;;AA4DA;EACE,8BAAA;EACA,gCAAA;AAzDF;;AA6DA;EACE;IACE,sBAAA;EA1DF;AACF;AA6DA;EACE;;;IAGE,WAAA;EA3DF;EA6DA;IACE,SAAA;IACA,gBAAA;EA3DF;EA6DA;IACE,WAAA;EA3DF;EA6DA;IACE,yBAAA;EA3DF;EA6DA;IACE,WAAA;EA3DF;AACF","sourcesContent":["@import \"./../../assets/variables\";\n.fms-header {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 9;\n  background: #fff;\n  border-bottom: 1px solid rgba(#000, 0.12);\n}\n.logo-section {\n  float: left;\n  padding: 0 20px 0 0px;\n  display: inline-flex;\n  > a {\n    align-self: center;\n    margin-left: 10px;\n  }\n  .logo {\n    height: auto;\n    max-height: 38px;\n    max-width: 150px;\n    margin-left: 5px;\n    margin-top: 0px;\n    display: block;\n  }\n  .icon {\n    vertical-align: top;\n  }\n  .collapse-header {\n    background: none;\n    border: 0;\n    float: left;\n    padding: 9px 12px;\n    border-radius: 0 0 26px 0;\n    cursor: pointer;\n    outline: 0;\n    color: white;\n    background: $hoverBg;\n  }\n}\n// .logo-section {\n//   .logo {\n//     height: auto;\n//     max-height: 38px;\n//     max-width: 150px;\n//     margin-left: 5px;\n//     margin-top: 0px;\n//   }\n//   .icon {\n//     vertical-align: top;\n//     &:hover {\n//       // color: white;\n//       // border-color: $borderColor;\n//       // background: $hoverBg;\n//     }\n//   }\n//   .collapse-header {\n//     background: none;\n//     border: 0;\n//     float: left;\n//     padding: 9px 12px;\n//     border-radius: 0 0 26px 0;\n//     cursor: pointer;\n//     outline: 0;\n//     color: white;\n//     background: $hoverBg;\n//   }\n//   float: left;\n//   padding: 0 20px 0 0px;\n// }\n.left-nav {\n  float: left;\n}\n.right-nav {\n  float: right;\n  \n  .nav{\n    margin-left: 58px;\n  }\n  .sub-menu.right-menu{\n    left: auto;\n    right: 0;\n  }\n}\n\n// .right-nav {\n//   float: right;\n//   background: #fff;\n//   color: $menuBg;\n//   border-radius: 0 0 0 40px;\n//   padding-left: 15px;\n//   .nav > li > a {\n//     height: 44px;\n//     display: inline-flex;\n//     align-items: center;\n//   }\n//   .has-menu {\n//     width: 150px;\n//     > a {\n//       white-space: nowrap;\n//       overflow: hidden;\n//       text-overflow: ellipsis;\n//       span,\n//       svg {\n//         vertical-align: middle;\n//       }\n//     }\n//   }\n// }\n.nav-container {\n  height: 46px;\n  font-size: 12px;\n  // background: $menuBg;\n  // box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  &:before,\n  &:after {\n    clear: both;\n    content: \"\";\n    display: block;\n  }\n}\n.nav {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  > li {\n    float: left;\n    margin-right: 4px;\n    color: $linkColor;\n    > a {\n      padding: 8px 15px;\n      font-weight: 400;\n      font-size: 13px;\n      border-radius: 6px;\n      margin-top: 5px;\n    }\n  }\n  a {\n    display: block;\n    padding: 9px;\n    color: $linkColor;\n    text-decoration: none;\n    line-height: 16px;\n  }\n  svg {\n    margin-right: 4px;\n    min-width: 1.25em;\n    min-height: 1.25em;\n    vertical-align: top;\n  }\n  span {\n    vertical-align: top;\n  }\n}\n.right-nav {\n  svg {\n    margin-right: 0;\n  }\n\n  .nav > li > a {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n.nav {\n  > li {\n    > a.active,\n    &:hover > a {\n      background: $hoverBg;\n      color: $hoverColor;\n      border-top-color: $hoverBorderColor;\n    }\n  }\n}\n\n.apps-menu .scrollable-area {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  height: 340px;\n  overflow: auto;\n}\n.apps-menu .default-view {\n  text-align: center;\n  li {\n    display: inline-block;\n    width: 30%;\n    text-align: center;\n    vertical-align: top;\n    padding: 0;\n  }\n  a {\n    box-sizing: border-box;\n    border: 1px solid transparent;\n    display: block;\n    height: 93px;\n    padding: 0;\n    padding-top: 20px;\n    &:hover {\n      color: $themeColor;\n      background: none;\n      border-color: $borderColor;\n    }\n  }\n  .apps-menu-icon {\n    display: block;\n    margin: 0 auto 10px;\n    min-width: 32px;\n    min-height: 32px;\n  }\n}\n\n.apps-search-form {\n  position: relative;\n  padding: 10px 15px 10px 45px;\n  .toggle-apps-view {\n    position: absolute;\n    top: 0;\n    left: 0;\n    color: $darkGrey;\n    padding: 12px 15px;\n    svg {\n      color: currentColor;\n    }\n  }\n  .searchAppsTextField {\n    width: 100%;\n    outline: 0;\n    padding: 2px 7px 2px 20px;\n    box-sizing: border-box;\n  }\n  .appsSearchFrom {\n    position: relative;\n    svg {\n      position: absolute;\n      left: 0;\n      top: 0;\n      padding: 5px;\n      min-width: inherit;\n      min-height: inherit;\n      color: $borderColor;\n    }\n  }\n}\n\n.viewAllApps {\n  background: $borderColor;\n  padding: 6px 12px;\n  margin-top: 36px;\n}\n.menuIcon {\n  display: none !important;\n  padding: 5px;\n  color: $linkColor;\n  cursor: pointer;\n}\n.nav-collapse {\n  transition: all 5s ease;\n}\n\n.demo-notification-bar {\n  color: #fff;\n  padding: 6px 12px;\n  a {\n    color: #ff2;\n    text-decoration: underline;\n  }\n}\n.notification-info {\n  background: #1976d2 !important;\n  border-color: #1976d2 !important;\n}\n\n// responsive\n@media (max-width: 1199px) {\n  .nav > li > a {\n    padding: 6px 15px 12px;\n  }\n}\n\n@media (max-width: 959px) {\n  .logo-section,\n  .right-nav,\n  .left-nav {\n    float: none;\n  }\n  .nav-collapse.collapse {\n    height: 0;\n    overflow: hidden;\n  }\n  .nav > li {\n    float: none;\n  }\n  .menuIcon {\n    display: block !important;\n  }\n  .logo-section {\n    width: auto;\n  }\n}\n","@import 'functions';\n@import 'mixins';\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
